import React from 'react';
import { Grid, Card, Typography, Box } from '@mui/material';
import { Cancel, Warning, Description } from '@mui/icons-material';

interface SeoIssuesProps {
  seo_issues: {
    critical: number;
    warnings: number;
    notices: number;
  };
}

const SeoIssues: React.FC<SeoIssuesProps> = ({ seo_issues }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Cancel color="error" />
            <Typography variant="h6">Problèmes critiques</Typography>
          </Box>
          <Typography variant="h3" fontWeight="bold" color="error">
            {seo_issues.critical}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Problèmes bloquants pour le référencement
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Warning color="warning" />
            <Typography variant="h6">Alertes</Typography>
          </Box>
          <Typography variant="h3" fontWeight="bold" color="warning.main">
            {seo_issues.warnings}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Problèmes importants à corriger
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <Description color="info" />
            <Typography variant="h6">Notices</Typography>
          </Box>
          <Typography variant="h3" fontWeight="bold" color="info.main">
            {seo_issues.notices}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Suggestions d'optimisation mineures
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SeoIssues;
